import { IS_HEIDI_LEARNS_ENABLED } from '@/app-shell/flags/shell-flags';
import { type getCurrentUser } from '@/hooks/query/useQueryUser';
import type { QuerySessionResponse } from '@heidi/session/contracts';
import { isPersonalizationGateOpen } from './isPersonalizationGateOpen';

export const getPersonalizationPreference = (
  input: { isPersonalizationApplied?: boolean | null },
  sessionFromCache: QuerySessionResponse | undefined,
  user: ReturnType<typeof getCurrentUser>
): boolean | undefined => {
  if (!Boolean(IS_HEIDI_LEARNS_ENABLED())) return false;
  // Opt-in gate runs before any per-session / per-user default so an explicit
  // `isPersonalizationApplied: true` cannot override an opted-out user.
  if (!isPersonalizationGateOpen(user)) return false;
  if (typeof input.isPersonalizationApplied === 'boolean') {
    return input.isPersonalizationApplied;
  }
  if (typeof sessionFromCache?.consult_note.is_personalization_applied === 'boolean') {
    return sessionFromCache?.consult_note.is_personalization_applied;
  }
  if (
    typeof user?.session_settings?.default_apply_personalization_insights === 'boolean'
  ) {
    return user?.session_settings?.default_apply_personalization_insights;
  }
  return undefined;
};
